const KeenSlider = window.KeenSlider

class SearchCtaCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    // Only initialize on mobile
    if (window.BAO?.MediaBreakpoints?.isLg || window.innerWidth >= 1110) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!KeenSlider || !this.els?.slides?.element) return null

    const slider = new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.2,
          spacing: 8,
        },
        created: () => {
          this.els.slides.element.setAttribute('data-initialised', true)
        },
      },
    )

    this.setupArrowListeners(slider)

    return slider
  }
}

if (!customElements.get('search-cta-carousel')) {
  customElements.define('search-cta-carousel', SearchCtaCarousel)
}
